import React from 'react';
import {
  Box,
  Button,
  Modal,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

interface PostModalProps {
  open: boolean;
  onClose: () => void;
  post: {
    id_Property: number;
    title: string;
    price: number;
    createdDate: Date;
    photos: string[];
  } | null;
  onEdit: () => void;
  onDelete: () => void;
}

const PostModal: React.FC<PostModalProps> = ({
  open,
  onClose,
  post,
  onEdit,
  onDelete,
}) => {
  
  const formatPrice = (price: number) => {
    return `₡${price.toLocaleString('es-CR')}`;
  };

  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(new Date(date));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          width: {xs:'80%', md: '90%'},
          maxWidth: 400,
          mx: 'auto',
          mt: { xs: '10vh', sm: '15vh' },
          position: 'relative',
        }}
      >
        {post && (
          <>
            <IconButton
              edge="end"
              color="inherit"
              onClick={onClose}
              sx={{ position: 'absolute', top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mb: 2,
              }}
            >
              <Box
                component="img"
                src={post.photos[0]}
                alt={post.title}
                sx={{
                  width: '100%',
                  height: { xs: 180, sm: 250 },
                  objectFit: 'cover',
                  borderRadius: '12px',
                }}
              />
              <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold', textAlign: 'center' }}>
                {post.title}
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 1, textAlign: 'center' }}>
                {`Precio: ${formatPrice(post.price)}`}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, textAlign: 'center' }}>
                {`Publicado: ${formatDate(post.createdDate)}`}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1 }}>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<EditIcon />}
                onClick={onEdit}
                sx={{
                  flex: 1,
                  '&:hover': { bgcolor: 'primary.main', color: 'white' },
                }}
              >
                Editar
              </Button>
              <Button
                variant="outlined"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={onDelete}
                sx={{
                  flex: 1,
                  '&:hover': { bgcolor: 'error.main', color: 'white' },
                }}
              >
                Eliminar
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
  
};

export default PostModal;
